import {
    GET_STAGE_OVERVIEW_LOADING,
    GET_STAGE_OVERVIEW_SUCCESS,
    GET_STAGE_OVERVIEW_FAILURE,
    GET_STAGE_OVERVIEW_RESET,
    GET_EVENT_OVERVIEW_LOADING,
    GET_EVENT_OVERVIEW_SUCCESS,
    GET_EVENT_OVERVIEW_FAILURE,
    GET_EVENT_OVERVIEW_RESET,
    UPDATE_STAGE_OVERVIEW,
} from "../../actions/types";

const INITIAL_STATE = {
    stageDetails: {
        get: {
            loading: false,
            reset: false,
            success: {
                ok: false,
                data: null,
            },
            failure: {
                error: false,
                message: "",
            },
        },
    },
    eventDetails: {
        get: {
            loading: false,
            reset: false,
            success: {
                ok: false,
                data: null,
            },
            failure: {
                error: false,
                message: "",
            },
        },
    },
};

const workTableReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_STAGE_OVERVIEW_LOADING:
            return {
                ...state,
                stageDetails: {
                    ...state.stageDetails,
                    get: {
                        ...state.stageDetails.get,
                        loading: true,
                        reset: false,
                        success: {
                            ...state.stageDetails.get.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: "",
                        },
                    },
                },
            };
        case GET_STAGE_OVERVIEW_SUCCESS:
            return {
                ...state,
                stageDetails: {
                    ...state.stageDetails,
                    get: {
                        ...state.stageDetails.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.stageDetails.get.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: "",
                        },
                    },
                },
            };
        case GET_STAGE_OVERVIEW_FAILURE:
            return {
                ...state,
                stageDetails: {
                    ...state.stageDetails,
                    get: {
                        ...state.stageDetails.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.stageDetails.get.success,
                            ok: false,
                            data: null,
                        },
                        failure: {
                            error: true,
                            message: action.payload.message,
                        },
                    },
                },
            };
        case GET_STAGE_OVERVIEW_RESET:
            return {
                ...state,
                stageDetails: {
                    ...state.stageDetails.get,
                    get: {
                        ...INITIAL_STATE.stageDetails.get,
                        reset: true,
                    },
                },
            };
        case UPDATE_STAGE_OVERVIEW:
            return {
                ...state,
                stageDetails: {
                    ...state.stageDetails,
                    get: {
                        ...state.stageDetails.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.stageDetails.get.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: "",
                        },
                    },
                },
            };
        case GET_EVENT_OVERVIEW_LOADING:
            return {
                ...state,
                eventDetails: {
                    ...state.eventDetails,
                    get: {
                        ...state.eventDetails.get,
                        loading: true,
                        reset: false,
                        success: {
                            ...state.eventDetails.get.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: "",
                        },
                    },
                },
            };
        case GET_EVENT_OVERVIEW_SUCCESS:
            return {
                ...state,
                eventDetails: {
                    ...state.eventDetails,
                    get: {
                        ...state.eventDetails.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.eventDetails.get.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: "",
                        },
                    },
                },
            };
        case GET_EVENT_OVERVIEW_FAILURE:
            return {
                ...state,
                eventDetails: {
                    ...state.eventDetails,
                    get: {
                        ...state.eventDetails.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.eventDetails.get.success,
                            ok: false,
                            data: null,
                        },
                        failure: {
                            error: true,
                            message: action.payload.message,
                        },
                    },
                },
            };
        case GET_EVENT_OVERVIEW_RESET:
            return {
                ...state,
                eventDetails: {
                    ...state.eventDetails.get,
                    get: {
                        ...INITIAL_STATE.eventDetails.get,
                        reset: true,
                    },
                },
            };
    }
    return state;
};

export default workTableReducers;
